<template>
  <div id="gameArea">
    <div>
      <div style="position: fixed; top: 0; left: 0;">
        <img :src="BbAudienceImg" style="width: 100vw; height: auto;">

        <game-information
            :red_score="red_score"
            :white_score="white_score"
            :game_flag="game_flag"
            :room_id="room_id"
            :game_end_time="game_end_time"
        />
      </div>

      <div style="display: flex; background-size: cover; background-repeat: no-repeat;" :style="{ 'background-image': 'url(' + BgGameArea + ')' }">
        <!-- Aチームのエリア -->
        <div style="width: 50vw; height: 100vh; padding: 25vw 1vw 23vh;" ref="getDddd">
          <div style="position: relative;">
            <!-- ユーザーの塊 -->
            <div v-for="(player, index) in red_member" :key="index" :style="{ top: getPlayerPosition('height') + 'px', left: getPlayerPosition('width') + 'px' }" style="position: absolute;">
              <div style="position: relative;">
                <div style="position: relative; z-index: 1; width: 48px; height: 48px; border-radius: 50%; background-color: white;">
                  <p style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">{{ player.name.charAt(0) }}</p>
                </div>
                <img :src="Fire" alt="" :style="{ width: getFireSize(player.score) + 'px', height: getFireSize(player.score) + 'px' }" style="position: absolute; bottom: 0; left: 50%; transform: translate(-50%, 0);">
              </div>
            </div>
            <!-- ユーザーの塊 -->
          </div>
        </div>
        <!-- Aチームのエリア -->

        <!-- Bチームのエリア -->
        <div style="width: 50vw; height: 100vh; padding: 25vw 1vw 23vh;" ref="getDddd">
          <div style="position: relative;">
            <!-- ユーザーの塊 -->
            <div v-for="(player, index) in white_member" :key="index" :style="{ top: getPlayerPosition('height') + 'px', left: getPlayerPosition('width') + 'px' }" style="position: absolute;">
              <div style="position: relative;">
                <div style="position: relative; z-index: 1; width: 48px; height: 48px; border-radius: 50%; background-color: white;">
                  <p style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">{{ player.name.charAt(0) }}</p>
                </div>
                <!-- TODO: ここで関数が2回呼ばれるのが、いつかネックになりそう -->
                <img :src="Fire" alt="" :style="{ width: getFireSize(player.score) + 'px', height: getFireSize(player.score) + 'px' }" style="position: absolute; bottom: 0; left: 50%; transform: translate(-50%, 0);">
              </div>
            </div>
            <!-- ユーザーの塊 -->
          </div>
        </div>
        <!-- Bチームのエリア -->
      </div>
    </div>
  </div>
</template>

<script>
import BgGameArea from '@/assets/bg_dk.gif'
import BbAudienceImg from "@/assets/bg_audience.png"
import Fire from "@/assets/fire.png"
import GameInformation from "./GameInformation";

export default {
  name: "GameArea",
  components: {
    GameInformation
  },
  props: {
    red_member: {
      type: Array,
      default: () => []
    },
    white_member: {
      type: Array,
      default: () => []
    },
    red_score: {
      type: Number,
      default: 0
    },
    white_score: {
      type: Number,
      default: 0
    },
    game_flag: {
      type: String,
      default: 'ready'
    },
    room_id: {
      type: String,
      default: ''
    },
    game_end_time: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      BgGameArea: BgGameArea,
      BbAudienceImg: BbAudienceImg,
      Fire: Fire
    }
  },
  methods: {
    getPlayerPosition(selectMode) {
      let maxWidth = this.$refs.getDddd.clientWidth
      let maxHeight = this.$refs.getDddd.clientHeight

      // NOTE: paddingを含まない値に変更
      maxWidth -= parseFloat(getComputedStyle(this.$refs.getDddd).paddingLeft) + parseFloat(getComputedStyle(this.$refs.getDddd).paddingRight)
      maxHeight -= parseFloat(getComputedStyle(this.$refs.getDddd).paddingTop) + parseFloat(getComputedStyle(this.$refs.getDddd).paddingBottom)

      if (selectMode === 'height') {
        return Math.floor(Math.random() * maxHeight) / 1.5;
      } else if (selectMode === 'width') {
        return Math.floor(Math.random() * maxWidth) / 1.5;
      }

      console.error('モードをセレクトしてください。')
      return 0;
    },
    getFireSize(voicePoint) {
      let fireSize = 0;

      if(voicePoint >= 300) {
        fireSize = 130;
      } else if (voicePoint >= 100) {
        fireSize = 100;
      } else if (voicePoint >= 50) {
        fireSize = 80;
      }

      return fireSize;
    }
  }
}
</script>

<style scoped>
#gameArea {

}
</style>
